import { render, staticRenderFns } from "./MediaPreview.vue?vue&type=template&id=232bd0ea&scoped=true"
import script from "./MediaPreview.vue?vue&type=script&lang=js"
export * from "./MediaPreview.vue?vue&type=script&lang=js"
import style0 from "./MediaPreview.vue?vue&type=style&index=0&id=232bd0ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232bd0ea",
  null
  
)

export default component.exports